module.exports = __webpack_public_path__ + "static/media/animal-fye.44eb8087.png";